import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, HandleLoginForm } from './components';

export const UnauthenticatedContent = () => {
  return (
    <Routes>
      <Route
        path='/login'
        element={
          <SingleCard title='Jetzt einloggen'>
            <LoginForm
            
            />
          </SingleCard>
        }
      />
      <Route
        path='/handleLogin'
        element={
          <SingleCard title='Anmelden wird verarbeitet'>
            <HandleLoginForm
            
            />
          </SingleCard>
        }
      />
    
      <Route path='*' element={<Navigate to='/login' />} />
    </Routes>
  );
};
